import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ClientPicker } from '@src/components/ClientPicker';
import classNames from 'classnames';
import { DatePicker, TrackableButton, useLocale } from 'pe-core-frontend';
import styles from './EmployeeFilter.module.scss';
export const EmployeeFilter = ({ filter, onFilterChange, className }) => {
    const { t } = useLocale();
    const handleReset = () => {
        onFilterChange({
            searchText: filter.searchText, // keep the search text
        });
    };
    return (_jsxs("div", { className: classNames(styles.employeeFilter, className), children: [_jsx("div", { className: styles.clientPicker, children: _jsx(ClientPicker, { clientId: filter.clientId, onChange: clientId => onFilterChange({ ...filter, clientId }) }) }), _jsx(DatePicker, { label: t('Start Date'), value: filter.startDate || '', onChange: startDate => onFilterChange({ ...filter, startDate }) }), _jsx(DatePicker, { label: t('End Date'), value: filter.endDate || '', onChange: endDate => onFilterChange({ ...filter, endDate }) }), _jsx(TrackableButton, { btnType: 'mui', enText: 'Reset', tag: 'employee_filter', onClick: handleReset, variant: 'outlined', color: 'primary', children: t('Reset') })] }));
};
